module.exports = __webpack_public_path__ + "assets/wrong-answer.ade3e926.svg";